import React, { useState } from 'react';
import { FaDiscord, FaTwitter } from 'react-icons/fa';
import '../styles/Footer.css';
import FileDisplayModal from './partial/modal/FileDisplayModal.jsx';
import '../styles/partial/modal/FileDisplayModal.css'; // Import the modal styles
import { useT } from '../contexts/LocaleContext.jsx';
import { useBroadcastGuard } from '../contexts/BroadcastSurface.jsx';

function Footer() {
  const t = useT();
  const [showFile, setShowFile] = useState(false);
  const [fileType, setFileType] = useState("tos");
  // Nothing displays over a broadcast (ENG-840): while a page shows one, the
  // documents open in a new tab instead of the full-screen modal.
  const onBroadcast = useBroadcastGuard().surfaces > 0;
  const openFile = (type) => {
    if (onBroadcast) {
      window.open(`/assets/docs/${type}.txt`, '_blank', 'noopener');
      return;
    }
    setFileType(type);
    setShowFile(true);
  };

  return (
    <footer className="footer">
      <div className="footer-left">
        <button
          className="footer-link"
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
          onClick={() => openFile("tos")}
        >
          {t('footer.termsOfService')}
        </button>
        <span> | </span>
        <button
          className="footer-link"
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
          onClick={() => openFile("privacy-policy")}
        >
          {t('footer.privacyPolicy')}
        </button>
      </div>

      <div className="footer-right">
        <a href="https://discord.gg/YpbSrpmMJc" className="footer-link" aria-label={t('footer.social.discord')}>
          <FaDiscord className="footer-icon" />
        </a>
        <a href="https://twitter.com" className="footer-link" aria-label={t('footer.social.twitter')}>
          <FaTwitter className="footer-icon" />
        </a>
      </div>
      <FileDisplayModal
        open={showFile && !onBroadcast}
        file={fileType}
        title={fileType === "tos" ? t('footer.termsOfService') : t('footer.privacyPolicy')}
        onClose={() => setShowFile(false)}
      />
    </footer>
  );
}

export default Footer;